import React from 'react';
import PropTypes from 'prop-types';
import InputElement from "react-input-mask";

const NumberInput = ({ name, label, onChange, placeholder, value, error, onFocus, onBlur }) => {
	let wrapperClass = 'form-group';
	if (error && error.length > 0) {
		wrapperClass += " " + "has-error";
	}
	value = value == null ? 0 : Number(value);
	let helpText = name == "PhoneNumber" ? <em>Example 123-456-7890</em> : null;
	let typeText = name == "PhoneNumber" ? "tel" : "number";

	return (
		<div className={wrapperClass} >
			<label htmlFor={name}>{label}<br/>{helpText}</label>
			<div className="field">
				<input
					type={typeText}
					name={name}
					className={error ? "form-control error" : "form-control"}
					placeholder={placeholder}
					value={value}
					min={Number(0)}
					onChange={onChange}
					onFocus={onFocus}
					onBlur={onBlur} />

				{error && <div className="alert alert-danger">{error}</div>}

			</div>
		</div>
	);
};

NumberInput.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	value: PropTypes.number,
	error: PropTypes.string,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func
}

export default NumberInput;



// WEBPACK FOOTER //
// ./src/components/common/NumberInput.js